import { SemesterCourse } from '../../../api/requests/curriculum';
import { FieldSelects, FormData } from './useTextValidationType';

export const defaultValues = {
  courseName: undefined,
  validationType: undefined,
  rapOption: undefined,
  examGrade: null,
  courseGrade: null,
  description: undefined,
  code: undefined,
  doc: undefined,
};

export const transformValidationType = ({
  course,
  options: { validationOptions, rapOptions },
}: {
  course: SemesterCourse | null;
  options: {
    validationOptions: FieldSelects['validationType'][];
    rapOptions: FieldSelects['rapOption'][];
  };
}): FormData =>
  course
    ? {
        courseName: course.course?.name,
        validationType:
          validationOptions.find(
            (e) => e.value === course?.validation?.validationType,
          ) || validationOptions[0],
        rapOption: rapOptions.find(
          (option) => option.value === course?.validation?.validationSubType,
        ),
        examGrade: course?.validation?.examGrade,
        courseGrade: course?.validation?.finalGrade,
        code: course?.validation?.code,
        description: course?.validation?.description,
        doc: course?.validation?.file,
        institution: course?.validation?.institutionName || '',
        externalCourseName: course?.validation?.externalCourseName || '',
        externalGrade: course?.validation?.externalGrade || '',
        supplementaryFiles: course?.validation?.supplementaryFiles || [],
      }
    : { ...defaultValues };
